import OTP_MODAL_TYPES from "./otpModalTypes";

const initialState = {
  showOtpModal: false,
  otpPhoneNumber: "",
  redirectionRequired: false,
  redirectScreen: "HOME",
};

export const otpModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case OTP_MODAL_TYPES.SHOW_OTP_MODAL:
      return {
        ...state,
        showOtpModal: true,
        otpPhoneNumber: action.payload.phoneNumber,
        redirectionRequired: action.payload.redirectionRequired,
        redirectScreen: action.payload.redirectScreen || "HOME",
      };
    case OTP_MODAL_TYPES.HIDE_OTP_MODAL:
      return {
        ...state,
        showOtpModal: false,
        otpPhoneNumber: "",
        redirectionRequired: false,
        redirectScreen: "HOME",
      };
    default:
      return state;
  }
};

// Action Creators
export const showOtpModal = ({
  phoneNumber,
  redirectScreen,
  redirectionRequired = false,
}) => ({
  type: OTP_MODAL_TYPES.SHOW_OTP_MODAL,
  payload: { phoneNumber, redirectScreen, redirectionRequired },
});

export const hideOtpModal = () => ({
  type: OTP_MODAL_TYPES.HIDE_OTP_MODAL,
});
